







import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * テキストを指定の高さで省略し、省略した際には末尾に省略記号(...)を付与する
 * 幅は親に対して100％固定
 * font-size・line-heightは親要素に準ずる
 */
@Component
export default class EllipsisComponent extends Vue {
  $refs!: {
    textContainer: Element;
  };

  @Prop({
    default: ""
  })
  // 表示テキスト
  originalText!: string;

  @Prop({
    default: 30
  })
  // 最大の高さ（これを越える場合省略する）
  // line-height * 表示したい行数 の数値を指定
  maxHeight!: Number;

  omittedText: String = "";

  @Watch("originalText")
  onTextChanged(newText: string) {
    this.showTextWithEllipsis(newText);
  }

  mounted() {
    this.showTextWithEllipsis(this.originalText);
  }

  /** 指定の高さで文字を省略 */
  showTextWithEllipsis(newText: string) {
    if (!this.$refs.textContainer || !newText) return;
    let text = `${newText}`;
    this.$refs.textContainer.innerHTML = text;
    this.$refs.textContainer.classList.remove("hidden");
    while (
      text.replace(/.\.\.\.$/, "").length > 0 &&
      this.$refs.textContainer.clientHeight > this.maxHeight
    ) {
      text = text.replace(/.\.\.\.$/, "");
      text = `${text}...`;
      this.$refs.textContainer.innerHTML = text;
    }
    this.$refs.textContainer.classList.add("hidden");
    this.omittedText = text;
  }
}
